module.exports = require('@bugsnag/browser')



//////////////////
// WEBPACK FOOTER
// ./~/@bugsnag/js/browser/notifier.js
// module id = 238
// module chunks = 1